// The bare identifier, wrapped in an object: synapse's `DefaultPayload` forbids a bare scalar.
export type FacilityTemplateOverrideRemovedPayload = {
	overrideId: number;
};

export type FacilityTemplateOverrideRemovedAction = {
	type: 'FACILITY_TEMPLATE_OVERRIDE_REMOVED';
	payload: FacilityTemplateOverrideRemovedPayload;
};

export default (payload: FacilityTemplateOverrideRemovedPayload): FacilityTemplateOverrideRemovedAction => ({
	type: 'FACILITY_TEMPLATE_OVERRIDE_REMOVED',
	payload,
});
